var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramLogoBw = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#instagram-logo-bw_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.027 0C18.64 0 24 5.36 24 11.973v.054C24 18.64 18.64 24 12.027 24h-.054C5.36 24 0 18.64 0 12.027v-.054C0 5.36 5.36 0 11.973 0zm-3.74 4.884a3.724 3.724 0 0 0-3.72 3.72v6.794c0 2.052 1.669 3.721 3.72 3.721h7.426c2.051 0 3.72-1.67 3.72-3.72V8.603c0-2.052-1.669-3.72-3.72-3.72zm7.426 1.312a2.41 2.41 0 0 1 2.408 2.408v6.794a2.41 2.41 0 0 1-2.408 2.408H8.287a2.41 2.41 0 0 1-2.408-2.408V8.604a2.41 2.41 0 0 1 2.408-2.408zM12 8.54A3.464 3.464 0 0 0 8.54 12 3.464 3.464 0 0 0 12 15.46 3.465 3.465 0 0 0 15.46 12 3.464 3.464 0 0 0 12 8.54m0 1.314A2.15 2.15 0 0 1 14.148 12 2.15 2.15 0 0 1 12 14.149a2.15 2.15 0 0 1-2.148-2.148A2.15 2.15 0 0 1 12 9.853m3.78-2.62a.933.933 0 1 0 .002 1.867.933.933 0 0 0-.002-1.867"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "instagram-logo-bw_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgInstagramLogoBw;